export const API_ENDPOINTS = {
  login: {
    SEND_OTP: 'Login/send-otp',
    VERIFY_OTP: 'Login/verify-otp',
    GOOGLE: 'Login/google',
    PROFILE: 'Login/profile',
  },
  CHILD: {
    FORMS: (childId: number) => `/Child/${childId}/forms`,
    BASE: '/Child',
  },
  FORM_CATEGORY: '/FormCategory',
  ANALYST: '/Analyst',
} as const;

export const ROLE_TYPES = {
  ADMIN: 'Admin',
  ANALYST: 'Analyst',
  CHILD: 'Child',
} as const;

export const LOCAL_STORAGE_KEYS = {
  TOKEN: 'token',
  SAVED_EMAILS: 'savedEmails',
  SAVED_USER_IDS: 'savedUserIds',
  MANUAL_LOGIN: 'manual-login-in-progress',
} as const;
